export const PLACES = {
  FETCH: "PLACES_FETCH",
  FETCH_SUCCESS: "PLACES_FETCH_SUCCESS",
  FETCH_FAILURE: "PLACES_FETCH_FAILURE",
};